import { useCallback } from "react";
import { DateHelper } from "../helpers";

/**
 * Hook to format and set updated date/time from shortage entry details.
 * @param setUpdatedDateTime - Setter for the formatted date/time string
 * @returns A function to call with the shortage entry details
 */
export function useDateTimeFormatter(setUpdatedDateTime: (val: string) => void) {
  return useCallback((allShortage: any) => {
    const { createdDate, lastUpdatedDate, createdTime, lastUpdatedTime } = allShortage || {};
    const date = createdDate && createdDate > lastUpdatedDate ? createdDate : lastUpdatedDate;
    const time =
      createdDate &&
      createdTime &&
      (createdDate > lastUpdatedDate ||
        (createdDate === lastUpdatedDate && createdTime > lastUpdatedTime))
        ? createdTime
        : lastUpdatedTime;
    if (date && time) {
      setUpdatedDateTime(DateHelper.mergerAS400DateTime(date, time));
    }
  }, [setUpdatedDateTime]);
}
